import Home from '../KonsaltingContainer/Home/Home';
import AboutUs from '../KonsaltingContainer/AboutUs/AboutUs';
import Testimonial from '../KonsaltingContainer/Testimonial/Testimonial';
import Services from '../KonsaltingContainer/Services/Services';
import Map from '../KonsaltingContainer/Map/Map';
import ContactUs from '../KonsaltingContainer/ContactUs/ContactUs';

export const TOTAL_SCREENS = [
  {
    screen_name: "Početna", 
    componnent: Home,
  },
   {
    screen_name: "O nama",
    componnent: AboutUs,
  },
  {
    screen_name: "Usluge",
    componnent: Services
  },
  
  {
    screen_name: "Svjedočanstva",
    componnent: Testimonial
  },

  {
    screen_name: "Lokacija",
    componnent: Map
  },

  {
    screen_name: "Kontakt",
    componnent: ContactUs
  },

];

export const GET_SCREEN_INDEX = (screen_name) => {
  if (!screen_name) return -1;

  for (let i = 0; i < TOTAL_SCREENS.length; i++) {
    if (TOTAL_SCREENS[i].screen_name === screen_name) return i;
  }
  return -1;
};
